export function checkIfAlreadyCollected(ids) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_collected",
        datatype: "json",
        data: {
            "ajax_call_ids": ids,
            "ajax_call_company": company,
            "ajax_call_shop_code": shopCode,
            "ajax_call_language_code": languageCode,
            "ajax_call_customer_no": customerNo
        },
        success: function (output) {
            var elements = $.parseJSON(output);
            $.each(elements, function (key, value) {
                var codebox = $(".codebox_primary:contains('" + value.code + "')");

                var container = codebox.closest(".timeline_entry.collection_points");
                var link = container.find(".redeem_code");
                link.addClass("inactive");
                link.text("Code bereits eingelöst");
            });
        }
    });
}